import { SecuritiesRewardsResponse } from '@swarm/types/api-responses'
import { SecuritiesRewardsTreeResponse } from '@swarm/types/api-responses/securities-rewards.response'

import config from '@core/config/index'

import { genericRequest } from './api'
import { MainnetNetwork } from './gas-estimator'

const getSecuritiesSmtRewards = (
  reportNumber: number,
  network: MainnetNetwork,
): Promise<SecuritiesRewardsResponse> =>
  genericRequest(
    `${config.rewardsUrl}/rd_${reportNumber}/smt_rd${reportNumber}_securities_rewards_${network}.json`,
    {
      shouldNotReturnDataProperty: true,
    },
  )

const getTreeInfo = async (
  owner: string,
  repository: string,
  sha: string | 'main',
): Promise<SecuritiesRewardsTreeResponse> =>
  genericRequest(
    `https://api.github.com/repos/${owner}/${repository}/git/trees/${sha}`,
    {
      shouldNotReturnDataProperty: true,
    },
  )

export default { getSecuritiesSmtRewards, getTreeInfo }
